import store from '@/store'
import NoticesBase from '../components/ModuleBase'
import NoticesDashboard from '../views/Dashboard'
import NoticeBase from '../components/NoticeBase'
import NoticeOverview from '../views/Overview'

const routes = [
  {
    path: '/notices/',
    component: NoticesBase,
    meta: { appKey: 'notices' },
    beforeEnter: (to, from, next) => {
      store.dispatch('clearSubnav')
      next()
    },
    children: [
      {
        path: 'dashboard',
        component: NoticesDashboard,
        name: 'NoticesDashboard'
      },
      {
        path: 'detail/:id/',
        component: NoticeBase,
        children: [
          {
            path: 'overview',
            name: 'NoticeOverview',
            component: NoticeOverview
          }
        ]
      }
    ]
  }
]

export default routes